/**
 * @description
 * Behavior for a card component - semantic grouping of objects
 * @specification
 * Adds role='group'.
 * Adds attribute 'aria-disabled=true' based on the property 'disabled'.
 */
export var cardBehavior = function cardBehavior(props) {
  return {
    attributes: {
      root: {
        role: 'group',
        'aria-disabled': props.disabled
      }
    }
  };
};
//# sourceMappingURL=cardBehavior.js.map
